module.exports = __webpack_public_path__ + "public/images/money.390eb4b8bfb500371f7ed1517e0f3056.png";